export const featureKey = 'genesysCloudCommonConversations';
